var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['borders', _vm.boardInfo.NSVuln ? 'nsVuln' : 'nsNonVuln', _vm.boardInfo.EWVuln ? 'ewVuln' : 'ewNonVuln' ]},[_c('div',{class:['number', _vm.small ? 'small' : 'large']},[_vm._v(_vm._s(_vm.number))]),(!_vm.small)?_c('div',{class:['dea' + ['N', 'E', 'S', 'W'][_vm.boardInfo.dealer], 'dealer']}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }